<template>
  <div class="fixed z-10 inset-0 overflow-y-auto">
    <div class="flex items-center py-8 justify-center min-h-screen">
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-black opacity-50"></div>
      </div>
      <div
        class="bg-white rounded-lg overflow-hidden shadow-xl px-6 py-6 z-50 min-w-[90vw] md:min-w-[40vw]"
      >
        <div class="flex justify-between items-center mb-6">
          <h2 class="text-xl font-medium text-gray-800 dark:text-white">
            Registro de clientes
          </h2>
          <button
            @click="isActive"
            class="text-gray-500 hover:text-gray-700 w-8 h-8 flex items-center justify-center hover:bg-gray-200 rounded-lg"
          >
            <svg class="w-5 h-5">
              <use href="../../assets/svg/icon.svg#cancel" />
            </svg>
          </button>
        </div>
        <form class="w-full space-y-6" @submit.prevent>
          <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            <label class="block">
              <span
                class="block mb-2 text-sm font-medium text-gray-800 dark:text-white"
              >
                Nombres <span class="text-red-300">*</span>
              </span>
              <input
                type="text"
                class="py-2 px-2 text-sm bg-gray-50 outline-none rounded-lg text-gray-600 w-full border-2 focus:border-blue-500"
                v-model="dataForm.names"
                placeholder="Nombres..."
                @keydown.enter.prevent
                maxlength="100"
              />
            </label>
            <label class="block">
              <span
                class="block mb-2 text-sm font-medium text-gray-800 dark:text-white"
              >
                Tipo de documentos
              </span>
              <TypeOfDocuments @send-data="getSelectTypeOfDocuments" />
            </label>
            <label class="block">
              <span
                class="block mb-2 text-sm font-medium text-gray-800 dark:text-white"
              >
                N° de documentos <span class="text-red-300">*</span>
              </span>
              <input
                type="number"
                class="py-2 px-2 text-sm bg-gray-50 outline-none rounded-lg text-gray-600 w-full border-2 focus:border-blue-500"
                v-model="dataForm.numberDocument"
                placeholder="N° de documentos..."
                @keydown.enter.prevent
                @keydown.enter="searchForDGII"
              />
            </label>
            <label class="block">
              <span
                class="block mb-2 text-sm font-medium text-gray-800 dark:text-white"
              >
                Dirección
              </span>
              <input
                type="text"
                class="py-2 px-2 text-sm bg-gray-50 outline-none rounded-lg text-gray-600 w-full border-2 focus:border-blue-500"
                v-model="dataForm.address"
                placeholder="Dirección..."
                @keydown.enter.prevent
                maxlength="100"
              />
            </label>
            <label class="block">
              <span
                class="block mb-2 text-sm font-medium text-gray-800 dark:text-white"
              >
                Teléfono / Celular
              </span>
              <input
                type="text"
                class="py-2 px-2 text-sm bg-gray-50 outline-none rounded-lg text-gray-600 w-full border-2 focus:border-blue-500"
                v-model="dataForm.phone"
                placeholder="Teléfono / Celular..."
                @keydown.enter.prevent
                maxlength="30"
              />
            </label>
            <label class="block">
              <span
                class="block mb-2 text-sm font-medium text-gray-800 dark:text-white"
              >
                Descuento límite asignado (%)
              </span>
              <input
                type="number"
                class="py-2 px-2 text-sm bg-gray-50 outline-none rounded-lg text-gray-600 w-full border-2 focus:border-blue-500"
                v-model="dataForm.discountLimit"
                placeholder="Descuento límite asignado..."
                @keydown.enter.prevent
              />
            </label>
            <label class="block">
              <span
                class="block mb-2 text-sm font-medium text-gray-800 dark:text-white"
              >
                Límite de crédito
              </span>
              <input
                type="number"
                class="py-2 px-2 text-sm bg-gray-50 outline-none rounded-lg text-gray-600  border-orange-500 w-full border-2 focus:border-blue-600"
                v-model="dataForm.creditLimit"
                placeholder="Límite de crédito..."
                @keydown.enter.prevent
              />
            </label>
            <label class="block">
              <span
                class="block mb-2 text-sm font-medium text-gray-800 dark:text-white"
              >
                Días de pago
              </span>
              <input
                type="number"
                class="py-2 px-2 text-sm bg-gray-50 outline-none rounded-lg text-gray-600  w-full border-2 focus:border-blue-600"
                v-model="dataForm.paydays"
                placeholder="Días de pago..."
                @keydown.enter.prevent
              />
            </label>
            <label class="block">
              <span
                class="block mb-2 text-sm font-medium text-gray-800 dark:text-white"
              >
                Tipo de cliente
              </span>
              <select
                class="border-2 bg-gray-50 py-2 text-sm px-3 text-gray-600 cursor-pointer rounded-lg mr-3 outline-none min-w-[140px] font-semibold w-full"
                v-model="dataForm.customerType"
              >
                <option value="RECURRENTE">RECURRENTE</option>
                <option value="CASUAL">CASUAL</option>
                <option value="GENERICO">GENERICO</option>
                <option value="PARTICULAR">PARTICULAR</option>
              </select>
            </label>
            <label class="block">
              <span
                class="block mb-2 text-sm font-medium text-gray-800 dark:text-white"
              >
                Vender con:
              </span>
              <select
                class="border-2 bg-gray-50 py-2 text-sm px-3 text-gray-600 cursor-pointer rounded-lg mr-3 outline-none min-w-[140px] font-semibold w-full"
                v-model="dataForm.sell_with"
              >
                <option value="1">PRECIO PRINCIPAL</option>
                <option value="2">PRECIO 2</option>
                <option value="3">PRECIO 3</option>
              </select>
            </label>
            <label class="block">
              <span
                class="block mb-2 text-sm font-medium text-gray-800 dark:text-white"
              >
              Fijar comprobante
              </span>
              <SelectVouchers @send-data="getSelectStore" />
            </label>
            <label class="block">
              <span
                class="block mb-2 text-sm font-medium text-gray-800 dark:text-white"
              >
                Correo electrónico
              </span>
              <input
                type="email"
                class="py-2 px-2 text-sm bg-gray-50 outline-none rounded-lg text-gray-600 w-full border-2 focus:border-blue-500 appearance-none"
                v-model="dataForm.email"
                placeholder="Correo electrónico..."
                @keydown.enter.prevent
                maxlength="30"
              />
            </label>
          </div>

          <div class="flex mt-[3.5rem!important] lg:mt-[2rem!important]">
            <button
              class="bg-blue-500 text-white px-4 py-2 font-semibold text-sm rounded-lg hover:shadow-sm hover:shadow-blue-600 active:scale-95 flex items-center"
              @click="insert"
              :disabled="spinner === true"
            >
              <div class="flex items-center" v-if="spinner">
                <svg class="w-4 h-4 mr-3 animate-spin">
                  <use href="../../assets/svg/icon.svg#spinnerForBlue" />
                </svg>
                Registrando Información
              </div>
              <span v-else>Registrar</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import { confirmationOfRecord, errorActions } from "@/alerts";
import { observer } from "@/observer";
import axios from "../../api";
import TypeOfDocuments from "@/components/PublicComponents/TypeOfDocuments.vue";
import {dgii} from '@/repository/DGII/dgii'
import SelectVouchers from "@/components/PublicComponents/SelectVouchers.vue";

export default {
  name: "RegisterCustomers",
  props: {
    activeModal: {
      type: Function,
      required: true,
    },
    getdata: {
      type: Function,
      required: true,
    },
  },
  components: {
    TypeOfDocuments,
    SelectVouchers
  },
  setup(props) {
    function isActive() {
      props.activeModal(true);
    }

    const spinner = ref(false); // Sirve para mostrar un loading al momento de enviar información

    const dataForm = ref({
      idTypeOfDocument: 0,
      names: "",
      address: "",
      numberDocument: "",
      phone: "",
      discountLimit: 0,
      sell_with: 1,
      creditLimit: 0,
      fixed_voucher: 0,
      paydays: 0,
      customerType: "CASUAL",
      email: "",
    });

    //recepcion de datos desde el componente publico, todas la sucursales
    const getSelectTypeOfDocuments = (data) => {
      dataForm.value.idTypeOfDocument = data;
    };

    const insert = async () => {
      if (dataForm.value.idTypeOfDocument <= 0) {
        errorActions("Selecciona un tipo de  <strong>documento</strong>");
        observer.observe(
          document.querySelector(".swal2-container"),
          { box: "content-box" },
          10
        );
        return;
      }
      if (dataForm.value.names.trim().length <= 2) {
        errorActions("Ingresa el nombre de un <strong>cliente</strong>");
        observer.observe(
          document.querySelector(".swal2-container"),
          { box: "content-box" },
          10
        );
        return;
      }
      if (dataForm.value.numberDocument <= 100000) {
        errorActions(
          "Ingresa un número de <strong>documento</strong> válido para el cliente"
        );
        observer.observe(
          document.querySelector(".swal2-container"),
          { box: "content-box" },
          10
        );
        return;
      }
      if (dataForm.value.discountLimit >100) {
        errorActions(
          "El límite de descuento  <strong>debe de ser menor a 100%</strong>"
        );
        observer.observe(
          document.querySelector(".swal2-container"),
          { box: "content-box" },
          10
        );
        return;
      }
      spinner.value = true;
      const response = await axios
        .post(
          "clientes",
          {
            idTypeOfDocument: dataForm.value.idTypeOfDocument,
            names: dataForm.value.names,
            address: dataForm.value.address,
            numberDocument: dataForm.value.numberDocument,
            phone: dataForm.value.phone,
            discountLimit: dataForm.value.discountLimit,
            creditLimit: dataForm.value.creditLimit,
            customerType: dataForm.value.customerType,
            email: dataForm.value.email,
            sell_with: dataForm.value.sell_with,
            fixed_voucher: dataForm.value.fixed_voucher,
            paydays: dataForm.value.paydays,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .catch(function (error) {
          errorActions(error);
        });
      const data = await response.data;
      if (data.msg === true) {
        confirmationOfRecord(
          `El cliente  <strong>${dataForm.value.names}</strong>`
        );
        props.getdata();
        dataForm.value.names = "";
        dataForm.value.address = "";
        dataForm.value.numberDocument = 0;
        dataForm.value.phone = '';
        dataForm.value.discountLimit = 0;
        dataForm.value.creditLimit = 0;
        dataForm.value.customerType = "CASUAL";
        dataForm.value.email = "";
      } else if (data.msg === "Request failed with status code 500") {
        errorActions("Request failed with status code 500");
      } else if (data.msg === "exist") {
        errorActions(
          `Ya existe un  <strong>cliente</strong> registrado con el número de documento que estas intentando registrar`
        );
      } else {
        errorActions(
          `Lo sentimos, no pudimos registrar el cliente <strong>${dataForm.value.names}</strong>`
        );
      }

      spinner.value = false; //dejando activo al boton
      observer.observe(
        document.querySelector(".swal2-container"),
        { box: "content-box" },
        10
      );
    };

    const getSelectStore = (data) => dataForm.value.fixed_voucher = data;

    const searchForDGII = async () => {
        const data =await  dgii(dataForm.value.numberDocument)
        if(data !== null) {
          dataForm.value.numberDocument = data.numberDocument
          dataForm.value.names = data.bussinesName
        }
    }

    return {
      isActive,
      dataForm,
      insert,
      spinner,
      getSelectTypeOfDocuments,
      searchForDGII,
      getSelectStore
    };
  },
};
</script>
